import PagesController from 'controllers/PagesController';
import Page from './Page';


export default new class {
	constructor() {
		PagesController.addPage( 'page', Page );
	}
};
